import React, { Fragment, useState, useEffect } from 'react'
import { Card, Modal } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import { serviceGetCfgForm } from '../../../../api/api-antecendentes-legales';
import Procesos from './componets/procesos';

const AntecedentesLegalesModal = ({ showAntecedentes, handleCloseAntecedentes }) => {
  const data_gestion_defensa = useSelector((state) => state.gestionDefensaReducer);
  const { llaves } = data_gestion_defensa;
  const [cfg_form, setCfg_form] = useState(null);

  useEffect(() => {
    if (llaves) getCfgForm();
  }, [llaves])

  const getCfgForm = async () => {
    const query = Buffer.from(JSON.stringify({ rutcia: llaves.idOrgCaso, idform: 45 })).toString('base64');
    const response = await serviceGetCfgForm(query);

    setCfg_form(response);
  }

  return (
    <Fragment>
      <Modal show={showAntecedentes} onHide={handleCloseAntecedentes} size='xl'>
        <Card>
          <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
            {cfg_form && cfg_form["modalantecedentesjudicialesdefensa-title"]}
          </Card.Header>

          <Card.Body>
            <Procesos
              cfg_form={cfg_form}
              handleCloseAntecedentes={handleCloseAntecedentes}
            />
          </Card.Body>
        </Card>
      </Modal>
    </Fragment>
  )
}

export default AntecedentesLegalesModal